// Import from webapp/i18n/ (global messages)
import global from '@/i18n/en-us/messages';

// Import from webapp/locales/ (domain messages - already migrated)
import app from '@/locales';

let messages = Object.assign({}, app, global);

export default { en: messages };
